export default __webpack_public_path__ + "static/media/brasao_ron.165311f9.png";